import { Injectable } from '@angular/core';
import { applyTransaction, Store, StoreConfig } from '@datorama/akita';
import { PatientModelDto } from '@shared/models/rx-models/interfaces/patient-model-dto';
import { emptyGuid } from '@shared/models/consts';
import { PatientModel } from '@shared/models/rx-models/interfaces/patient-model';
import { DateOfBirthUtils } from '@shared/utils/date-of-birth-utils';
import type { Maybe } from '@/types/globals';

export interface PatientState {
	patientAppUrl: string | null;
	patient: PatientModel | null;
	isPatientInConflict: boolean | null;
	isPatientAppConfigured: boolean;
	isPatientCleared: boolean;
}

export const createInitialState = (): PatientState => ({
	patientAppUrl: null,
	patient: null,
	isPatientInConflict: null,
	isPatientAppConfigured: false,
	isPatientCleared: false
});

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'patient' })
export class PatientStore extends Store<PatientState> {
	constructor() {
		super(createInitialState());
	}

	updatePatient(patient: PatientModelDto, dateFormat?: Maybe<string>, regulatoryDOBMask?: Maybe<string>): void {
		applyTransaction(() => {
			const dateOfBirth =
				patient.DateOfBirth instanceof Date
					? patient.DateOfBirth
					: DateOfBirthUtils.getDate(patient.DateOfBirth, dateFormat, regulatoryDOBMask);

			this.update({ patient: { ...patient, DateOfBirth: dateOfBirth } as PatientModel, isPatientCleared: false });

			if (patient.UID && patient.UID !== emptyGuid) {
				this.update({ isPatientInConflict: false });
			}
		});
	}

	clearPatient(): void {
		this.update({ patient: null, isPatientCleared: true });
	}
}
